module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cTnOm"))).then(() => parcelRequire('hEqeo'));